module.exports = __webpack_public_path__ + "img/clients.481d9a7e.svg";